import React from 'react';
import { HeartCrack, EyeOff, RefreshCcw, AlertCircle, UserMinus } from 'lucide-react';
import { FadeIn } from './FadeIn';
const painPoints = [{
  icon: HeartCrack,
  title: 'Lo tenía… y lo perdí sin entender por qué',
  desc: "Empiezan hablando bien… risas, conexión… y de repente: respuestas cortas, silencio, indiferencia. Te quedas revisando el chat pensando: '¿Dije algo mal?'"
}, {
  icon: EyeOff,
  title: 'Quedarse en visto (el golpe silencioso)',
  desc: "Ese momento donde él ve el mensaje… y no responde. Pasa 1 hora… 3 horas… 1 día… Ese 'en visto' no es solo un mensaje, es una puñalada directa al autoestima."
}, {
  icon: RefreshCcw,
  title: 'Ser la que siempre intenta más',
  desc: "Tú inicias la conversación. Tú sostienes el tema. Tú vuelves a escribir… Mientras él responde cuando quiere. Y en el fondo sabes: 'Si dejo de escribir… esto se muere.'"
}, {
  icon: AlertCircle,
  title: 'Miedo a decir lo incorrecto',
  desc: "Piensas demasiado cada mensaje: '¿Muy intensa?' '¿Muy fría?' '¿Muy aburrida?' Esa duda constante mata la naturalidad… y termina alejando más."
}, {
  icon: UserMinus,
  title: 'Sentirse reemplazable',
  desc: "Ves que él sigue activo… seguro hablando con otras. Y aparece el pensamiento más doloroso: 'No soy suficiente para que él se quede.'"
}];
export function PainPoints() {
  return <section className="py-14 px-6 bg-[#161616] relative" data-id="element-223">
      <div className="max-w-5xl mx-auto" data-id="element-224">
        <FadeIn data-id="element-225">
          <div className="text-center mb-10" data-id="element-226">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4" data-id="element-227">
              ¿Te resulta{' '}
              <span className="text-brand-rose italic" data-id="element-228">familiar?</span>
            </h2>
            <p className="text-brand-lightGray text-lg max-w-2xl mx-auto" data-id="element-229">
              No es que él esté ocupado. No es que no haya visto tu mensaje. No
              es que "los hombres son así".
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-230">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-brand-gray/30 border border-white/5 p-6 rounded-2xl hover:bg-brand-gray/50 transition-colors ${index === 3 ? 'md:col-span-2 lg:col-span-1' : ''} ${index === 4 ? 'md:col-span-2 lg:col-span-2' : ''}`} data-id="element-231">
              <div className="w-10 h-10 bg-brand-rose/10 rounded-xl flex items-center justify-center mb-4 text-brand-rose" data-id="element-232">
                <point.icon className="w-5 h-5" data-id="element-233" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-brand-cream" data-id="element-234">
                {point.title}
              </h3>
              <p className="text-brand-lightGray leading-relaxed text-sm" data-id="element-235">
                {point.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}